import {observer} from "mobx-react";
import {Box, Button, Stack, Typography} from "@mui/material";
import React from "react";
import {useNavigate} from "react-router-dom";

interface ErrorPanelProps {
    message: string
}

export const NotFound = observer(() => {
    return <ErrorPanel message={'Oops! We could not find the page you were looking for!'}/>;
});
export const ServerError = observer(() => {
    return <ErrorPanel message={'Oops! Something went wrong on the server side. Please try again later.'}/>;
});

function ErrorPanel(props: ErrorPanelProps) {
    const {message} = props;
    const navigate = useNavigate();
    const handleReturn = () => {
        navigate('/');
    }
    return (
        <Box
            display={'flex'}
            alignItems={'center'}
            justifyContent={'center'}
            sx={{minHeight: '80vh', p: 5}}
        >
            <Stack>
                <Typography variant={"h2"} align={'center'}>
                    {message}
                </Typography>
                <Box
                    display={'flex'}
                    alignItems={'center'}
                    justifyContent={'center'}
                    sx={{p: 5}}
                >
                    <Button
                        variant="contained"
                        onClick={handleReturn}
                    >
                        Return to start page
                    </Button>
                </Box>
            </Stack>
        </Box>
    )
}